import React from 'react';
import { Clock, ClipboardList, Timer, FileText, UserCheck, Network, BookOpen, CalendarDays } from 'lucide-react';
import ConfigCard from '../ConfigCard';
import MOMWorkingDaysUpload from '../MOMWorkingDaysUpload';

const PoliciesTab = ({ configData, cardProps }) => (
  <div className="space-y-6">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <ConfigCard {...cardProps} title="Workweek Policies" icon={Clock}
        items={configData.workweekPolicies}
        category="workweekPolicies"
        fields={['hours_per_week', 'break_hours_required']}
      />
      <ConfigCard {...cardProps} title="Overtime Policies" icon={Timer}
        items={configData.overtimePolicies}
        category="overtimePolicies"
        fields={['multiplier', 'daily_limit_hours']}
      />
    </div>
    <ConfigCard {...cardProps} title="Work Schedule Templates" icon={ClipboardList}
      items={configData.workScheduleTemplates}
      category="workScheduleTemplates"
      fields={['schedule_type_display', 'start_time', 'end_time', 'working_days', 'total_hours_per_week']}
    />
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <ConfigCard {...cardProps} title="Notice Period Policies" icon={FileText}
        items={configData.noticePolicies}
        category="noticePolicies"
        fields={['service_length_min', 'notice_days']}
      />
      <ConfigCard {...cardProps} title="Retirement Policies" icon={UserCheck}
        items={configData.retirementPolicies}
        category="retirementPolicies"
        fields={['retirement_age', 'reemployment_age']}
      />
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <ConfigCard {...cardProps} title="Competency Frameworks" icon={Network}
        items={configData.competencyFrameworks}
        category="competencyFrameworks"
        fields={['description']}
      />
      <ConfigCard {...cardProps} title="CPD Requirements" icon={BookOpen}
        items={configData.cpdRequirements}
        category="cpdRequirements"
        fields={['trade_category_name', 'annual_hours_required']}
      />
    </div>
    <div>
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <CalendarDays className="w-5 h-5 text-gray-500" />
        Working Days Calendar
      </h3>
      <MOMWorkingDaysUpload />
    </div>
  </div>
);

export default PoliciesTab;
